module.exports = __webpack_public_path__ + "assets/certificate_pdf/Microsys Solution Certified Specialist – Network, Infrastructure_1A8BA88A.a7c96317.pdf";